
export const SUPER_ADMIN_INDEX_ROUTE = "sectors";
export const ADMIN_INDEX_ROUTE = "roles"
export const DASHBOARD_USER_INDEX_ROUTE = "widget-dashboard"